const DB_NAME = 'derma_recordings';
const STORE = 'chunks';

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(db, mode) {
  return db.transaction(STORE, mode).objectStore(STORE);
}

const key = (sessionId, seq) => `${sessionId}:${String(seq).padStart(6, '0')}`;

export async function saveChunk(sessionId, seq, blob) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const r = tx(db, 'readwrite').put(blob, key(sessionId, seq));
    r.onsuccess = resolve;
    r.onerror = () => reject(r.error);
  });
}

export async function getSessionBlob(sessionId) {
  const db = await openDB();
  const range = IDBKeyRange.bound(`${sessionId}:`, `${sessionId};`);
  return new Promise((resolve, reject) => {
    const r = tx(db, 'readonly').getAll(range);
    r.onsuccess = () => {
      const parts = r.result || [];
      resolve(parts.length ? new Blob(parts, { type: 'audio/webm' }) : null);
    };
    r.onerror = () => reject(r.error);
  });
}

export async function clearSession(sessionId) {
  const db = await openDB();
  const range = IDBKeyRange.bound(`${sessionId}:`, `${sessionId};`);
  return new Promise((resolve) => {
    const r = tx(db, 'readwrite').delete(range);
    r.onsuccess = resolve;
    r.onerror = resolve;
  });
}
